import React from 'react';
import Icon from '@common/assets';
import UserInfo from '@components/phs/test/userInfoArea/userInfo';
import { EventServiceList, ServiceList } from './serviceList';
import { DChampsCountHeader } from '../dChampsContents';
import Colors from '@domain/constant/colors';
import { V2Route } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './userInfoArea.module.scss';
const cx = classnames.bind(styles);

const UserInfoArea = () => {
  return (
    <div className={cx('userInfoArea')}>
      <a href={V2Route.getPhsPreparePage()} target={'_blank'} className={cx('link')} rel="noreferrer">
        <div className={cx('linkText')}>개발자검사 응시 전, 꼭 확인하세요</div>
        <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_JOBDA_WHITE} />
      </a>

      {/* 개발자 검사 역량 유형 영역 */}
      <div className={cx('serviceArea')}>
        {/* 역량 유형(유저 정보) 영역 */}
        <UserInfo />

        {/* 개발자센터 서비스 영역 */}
        <ServiceList />
      </div>
    </div>
  );
};

const EventUserInfoArea = () => {
  return (
    <div className={cx('userInfoArea')}>
      <div className={cx('noticeArea')}>
        <a href={V2Route.getPhsPreparePage()} target={'_blank'} className={cx('link')} rel="noreferrer">
          <div className={cx('linkText')}>개발자검사 응시 전, 꼭 확인하세요</div>
          <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_JOBDA_WHITE} />
        </a>

        {/*디챔스 정보 시간 영역 */}
        <DChampsCountHeader />
      </div>

      {/* 개발자 검사 역량 유형 영역 */}
      <div className={cx('serviceArea')}>
        {/* 역량 유형(유저 정보) 영역 */}
        <UserInfo />

        {/* 개발자센터 서비스 영역 */}
        <EventServiceList />
      </div>
    </div>
  );
};

export { UserInfoArea, EventUserInfoArea };
